module.exports = __webpack_public_path__ + "static/media/1_SE_IPPF_logo_1.23e84beb.png";